import cn from 'classnames';
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { ModalCloseClickLocation } from './consts';

export const ModalBackdrop: React.FC<{
  isShowing: boolean;
  onBackdropClick?: (clickLocation: ModalCloseClickLocation) => void;
}> = ({ isShowing, onBackdropClick }) => {
  const handleCloseClick = () => {
    onBackdropClick?.('backdrop-click');
  };

  const preventWheel: React.WheelEventHandler<HTMLDivElement> = (e) => {
    // Prevent background from scrolling when user scrolls over the overlay area
    e.preventDefault();
    e.stopPropagation();
  };

  const preventTouchMove: React.TouchEventHandler<HTMLDivElement> = (e) => {
    // Prevent iOS/Android touch scroll on the page behind the modal
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <CSSTransition in={isShowing} unmountOnExit timeout={150}>
      <div
        className={cn('fixed inset-0 z-modal-backdrop touch-none overscroll-contain bg-black', {
          'h-0 w-0 opacity-0': !isShowing,
          'opacity-40 transition': isShowing,
        })}
        onClick={handleCloseClick}
        onWheel={preventWheel}
        onTouchMove={preventTouchMove}
      />
    </CSSTransition>
  );
};
